import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import { deleteHotel, getHotelList } from "../../../api/admin/hotel";
import TableLoader from "../../../components/admin/usable/TableLoader";
import { Switch } from "@mui/joy";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import ViewButton from "../../../components/admin/usable/actions/ViewButton";
import { useNavigate } from "react-router";
import CalendarButton from "../../../components/admin/usable/actions/CalendarButton";
import DuplicateButton from "../../../components/admin/usable/actions/DuplicateButton";
import { useDispatch } from "react-redux";
import { setDuplicateHotel } from "../../../redux/admin/dupHotelSlice";

const HotelList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [HotelData, setHotelData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(20);
  const [PageData, setPageData] = useState("");
  useEffect(() => {
    getHotelList(setHotelData, Page, Limit, setPageData);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(HotelData);
    } else {
      const result = HotelData.filter((item) =>
        item.hotelName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, HotelData]);
  const handleDelete = (item) => {
    const id = item.hotelId;
    deleteHotel(setHotelData, setPageData, Page, Limit, id);
  };
  const handleDuplicate = (item) => {
    if (item) {
      dispatch(setDuplicateHotel(item));
      navigate("/admin/hotel/duplicate");
    }
  };
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search Hotel"
        />
        <AddButton
          onClick={() => navigate("/admin/hotel/create")}
          text="Add Hotel"
        />
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Hotel Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Company Logo
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Company Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Commission Rate
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Featured
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Dhoorbin Choice
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Customer Choice
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {FilteredData.length > 0 ? (
              <>
                {FilteredData.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-8 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-contain"
                            src={item.hotelLogo}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.hotelName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <div className="w-20 h-8 overflow-hidden rounded-lg">
                          <img
                            className="w-full h-full object-contain"
                            src={item.companyLogo}
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.companyName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-center">
                        {item.commissionRate || 0}%
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <Switch
                          checked={item.isFeatured === 1 ? true : false}
                        />
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <Switch
                          checked={item.isDhoorbinChoice === 1 ? true : false}
                        />
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700">
                        <Switch
                          checked={item.isCustomerChoice === 1 ? true : false}
                        />
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.createdAt.slice(0, 10)}
                      </td>
                      <td className="px-4 py-3 text-sm">
                        <div className="flex gap-x-2">
                          <DuplicateButton
                            onClick={() => handleDuplicate(item)}
                          />
                          <CalendarButton
                            onClick={() =>
                              navigate(`/admin/rooms/available/${item.hotelId}`)
                            }
                          />
                          {/* <ViewButton
                            onClick={() =>
                              navigate(`/admin/hotel/view/${item.hotelId}`)
                            }
                          /> */}
                          <EditButton
                            onClick={() =>
                              navigate(`/admin/hotel/edit/${item.hotelId}`)
                            }
                          />
                          <DeleteButton onClick={() => handleDelete(item)} />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={11} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {(Page - 1) * Limit + 1} to{" "}
          {(Page - 1) * Limit + HotelData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default HotelList;
